import { Component, OnInit } from '@angular/core';
import { AuthService, FormErrors, ResetForm } from "../login/auth.service";
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetPage implements OnInit {

  public form: ResetForm = new ResetForm
  public errors: FormErrors = new FormErrors
  public result: boolean

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {
    let hash = this.route.snapshot.paramMap.get('hash');
    this.form.hash = hash;
  }

  reset() {
    this.authService.reset(this.form).then(res => {
        this.result = true;
        this.errors.list = [];
        // this.router.navigate([this.authService.getAuth().isAdmin() ? 'admin' : 'dashboard']);
      }, err => {
          this.result = false;
          this.errors.list = err.json().errors;
      });
  }

  public authorized() {
    return this.authService.getAuth().isAuthorized();
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/reset/reset.component.ts